var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 24,
    fill: "none",
    viewBox: "0 0 103 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    fillRule: "evenodd",
    d: "M15.817 14.848L12.66 6.354l-3.124 8.494h6.28zM36.368 0c4.867 0 8.944 1.91 10.72 6.749L41.76 8.757c-.987-2.14-2.664-3.555-5.393-3.555-3.584 0-6.083 2.996-6.083 6.781 0 3.82 2.499 6.782 6.215 6.782 2.729 0 4.472-1.415 5.458-3.522l5.327 1.975C45.51 22.058 41.63 24 36.5 24c-7.53 0-12.233-5.136-12.233-11.983C24.267 5.136 28.97 0 36.368 0zm55.176 0c4.867 0 8.945 1.91 10.72 6.749l-5.327 2.008c-.986-2.14-2.663-3.555-5.393-3.555-3.584 0-6.083 2.996-6.083 6.781 0 3.82 2.5 6.782 6.215 6.782 2.73 0 4.472-1.415 5.458-3.522l5.328 1.975C100.686 22.058 96.806 24 91.676 24c-7.53 0-12.233-5.136-12.233-11.983C79.444 5.136 84.147 0 91.544 0zM15.718.46l9.7 23.046h-6.214l-1.645-4.247H7.826l-1.644 4.247H0L9.7.461h6.018zm52.415 0v5.104h-6.939v17.942h-5.919V5.564h-7.004V.46h19.862zm8.516 0v23.046h-5.886V.461h5.886z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.254bbb4d88aa51ba13fff8d8d65591c9.svg";
export { ForwardRef as ReactComponent };